export default __webpack_public_path__ + "static/media/museosans-700.843c224a.ttf";